import bindAll from 'lodash.bindall';
import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import {projectTitleInitialState} from '../reducers/project-title';
import {downloadBlob, saveFile} from '../lib/download-blob';
// import {Canvg} from 'canvg';
// import html2canvas from 'html2canvas';
/**
 * Project saver component passes a downloadProject function to its child.
 * It expects this child to be a function with the signature
 *     function (downloadProject, props) {}
 * The component can then be used to attach project saving functionality
 * to any other component:
 *
 * <SB3Downloader>{(downloadProject, props) => (
 *     <MyCoolComponent
 *         onClick={downloadProject}
 *         {...props}
 *     />
 * )}</SB3Downloader>
 */
class SB3Downloader extends React.Component {
    constructor (props) {
        super(props);
        bindAll(this, [
            'downloadProject'
        ]);
    }
    formatDate () {
        // 获取当前时间的时间戳
        const now = Date.now();

        // 将时间戳转换为Date对象
        const date = new Date(now);

        // 获取年、月（需要+1因为月份是从0开始的）、日、小时和分钟
        const year = date.getFullYear();
        const month = date.getMonth() + 1; // 月份是从0开始的
        const day = date.getDate();
        const hours = date.getHours();
        const minutes = date.getMinutes();

        // 格式化为字符串，确保月、日、小时和分钟为两位数字
        return `${year}年${month.toString().padStart(2, '0')}月${day
            .toString()
            .padStart(2, '0')}日${hours.toString().padStart(2, '0')} : ${minutes
            .toString()
            .padStart(2, '0')}`;

    }

    downloadProject () {
        const url = 'https://frog-backend.youngcode.net/scratch/save';
        this.props.saveProjectSb3().then(content => {
            if (this.props.onSaveFinished) {
                this.props.onSaveFinished();
            }
            // ${sessionStorage.getItem('userName')}-${this.formatDate()}${this.props.projectFilename}
            const fileName = `${this.props.projectFilename}`;
            // downloadBlob(fileName, content);
            saveFile(url, content, fileName, true);
        });

        //     // const url = 'https://frog-backend.youngcode.net/scratch/save';
    //     // const url = 'http://10.100.160.253:8016/report/createStudentReport';
    //     const url = 'https://frog-backend.youngcode.net/report/createStudentReport';
    //     this.props.saveProjectSb3().then(content => {
    //         if (this.props.onSaveFinished) {
    //             this.props.onSaveFinished();
    //         }
    //         // ${sessionStorage.getItem('userName')}-${this.formatDate()}${this.props.projectFilename}
    //         const fileName = `${this.props.projectFilename}`;
    //         // 下载到本地
    //         // downloadBlob(fileName, content);
    //
    //         // 截图代码 document.body
    //         const targetElement = document.querySelector('g.blocklyBlockCanvas');
    //         if (targetElement) {
    //             let svgContent = `
    // <svg xmlns="http://www.w3.org/2000/svg"
    //      xmlns:xlink="http://www.w3.org/1999/xlink"
    //      width="1159" height="1226">
    //   ${targetElement.outerHTML}
    // </svg>`;
    //             // 替换所有的 &nbsp; 为其等价的 Unicode 字符 &#160;
    //             svgContent = svgContent.replace(/&nbsp;/g, '&#160;');
    //             const canvas = document.createElement('canvas');
    //             canvas.width = 1159; // 设置与 SVG 宽度一致
    //             canvas.height = 1226; // 设置与 SVG 高度一致
    //
    //             const ctx = canvas.getContext('2d');
    //             const v = Canvg.fromString(ctx, svgContent);
    //
    //             v.render().then(() => {
    //                 document.body.appendChild(canvas); // 将 Canvas 添加到 DOM 中以便于调试
    //                 html2canvas(canvas).then(screenshotCanvas => {
    //                     // const screenshotBase64 = screenshotCanvas.toDataURL('image/png');
    //                     // console.log(screenshotBase64);
    //                     // // 移除 Canvas 元素
    //                     // document.body.removeChild(canvas);
    //                     screenshotCanvas.toBlob(blob => {
    //                         // 创建一个 FormData 对象
    //                         upFile(url, content, fileName, blob);
    //                         document.body.removeChild(canvas);
    //                     }, 'image/png');
    //                 })
    //                     .catch(error => {
    //                         console.error('Error capturing screenshot:', error);
    //                         document.body.removeChild(canvas);
    //                     });
    //             })
    //                 .catch(error => {
    //                     console.error('Error rendering SVG to Canvas:', error);
    //                 });
    //         } else {
    //             console.error('Target element not found');
    //         }
    //     });
    }
    render () {
        const {
            children
        } = this.props;
        return children(
            this.props.className,
            this.downloadProject
        );
    }
}

const getProjectFilename = (curTitle, defaultTitle) => {
    const filenameTitle = curTitle + defaultTitle;
    // if (!filenameTitle || filenameTitle.length === 0) {
    //     filenameTitle = defaultTitle;
    // }
    // console.log(filenameTitle);
    return `${filenameTitle.substring(0, 100)}.sb3`;
};

SB3Downloader.propTypes = {
    children: PropTypes.func,
    className: PropTypes.string,
    onSaveFinished: PropTypes.func,
    projectFilename: PropTypes.string,
    saveProjectSb3: PropTypes.func
};
SB3Downloader.defaultProps = {
    className: ''
};

const mapStateToProps = state => ({
    saveProjectSb3: state.scratchGui.vm.saveProjectSb3.bind(state.scratchGui.vm),
    projectFilename: getProjectFilename(state.scratchGui.projectTitle, projectTitleInitialState)
});

export default connect(
    mapStateToProps,
    () => ({}) // omit dispatch prop
)(SB3Downloader);
